module.exports = __webpack_public_path__ + "static/media/dutch-flag.13449429.svg";